/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const es_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const de_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht`)
};

const nl_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht`)
};

const fr_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids`)
};

const it_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const pt_br2_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const pt_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const ja_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質量`)
};

const zh_uc_cat_weight = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_weight = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_weight(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_weight", locale)
	if (locale === "en") return en_uc_cat_weight(inputs)
	if (locale === "es") return es_uc_cat_weight(inputs)
	if (locale === "de") return de_uc_cat_weight(inputs)
	if (locale === "nl") return nl_uc_cat_weight(inputs)
	if (locale === "fr") return fr_uc_cat_weight(inputs)
	if (locale === "it") return it_uc_cat_weight(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_weight(inputs)
	if (locale === "pt") return pt_uc_cat_weight(inputs)
	if (locale === "ja") return ja_uc_cat_weight(inputs)
	return zh_uc_cat_weight(inputs)
};